import { sum } from "./arrays"

export function getTotals(
  items: {
    price_pennies: number | null
    quantity: number | null
    discountPercent: number | null
    product?: { id: string } | null
    opportunity_certificate_cost_discount_amount_pennies?: number | null
  }[],
  carriage_pennies: number | null,
  taxRate?: number | null,
  productRebates?: Record<string, number | null>,
) {
  const VAT_RATE = (taxRate ?? 20) / 100

  const subTotalPennies = sum(items, item => (item?.price_pennies ?? 0) * (item?.quantity ?? 0))

  const discountPennies = sum(
    items,
    item =>
      (item?.price_pennies ?? 0) * (item?.quantity ?? 0) * ((item?.discountPercent ?? 0) / 100),
  )
  const branchDiscountPennies = sum(items, item => {
    if (item.opportunity_certificate_cost_discount_amount_pennies) {
      return item.opportunity_certificate_cost_discount_amount_pennies * (item.quantity ?? 0)
    }
    return 0
  })

  const rebateAmountPennies = sum(items, item => {
    if (item.product?.id && productRebates?.[item.product.id]) {
      const itemPriceWithDiscount = item.discountPercent
        ? item.price_pennies! * ((100 - (item.discountPercent ?? 0)) / 100)
        : item.price_pennies!
      const itemPrice = itemPriceWithDiscount * (item.quantity ?? 1)
      return (itemPrice * (productRebates?.[item.product.id] ?? 0)) / 100
    }
    return 0
  })

  const totalNetPennies = subTotalPennies - discountPennies + (carriage_pennies ?? 0)

  const totalGrossPennies = totalNetPennies * (1 + VAT_RATE)

  const vatPennies = totalGrossPennies - totalNetPennies

  return {
    subTotalPennies,
    discountPennies,
    vatPennies,
    totalPricePennies: totalGrossPennies,
    totalNetPennies,
    rebateAmountPennies,
    branchDiscountPennies,
  }
}
